import { useState } from "react";
import { Container, Content, Header, Main } from "./styles";
import { FaShoppingBasket, FaStoreAlt, FaTimes } from "react-icons/fa";

export function QuestionModal({ sendOrder, onClose }) {
	const [finishingOrder, setFinishingOrder] = useState(false);

	async function handleClickButton(value) {
		setFinishingOrder(true);
		await sendOrder(value);
		setFinishingOrder(false);
	}

	return (
		<Container>
			<Content>
				<Header>
					<button onClick={onClose}>
						<FaTimes />
					</button>
				</Header>

				<Main>
					<p>Deseja consumir o pedido na loja?</p>

					<div className="containerButtons">
						<button
							type="button"
							onClick={() => handleClickButton(true)}
							disabled={finishingOrder}
						>
							<FaStoreAlt /> Consumir na loja
						</button>

						<button
							type="button"
							onClick={() => handleClickButton(false)}
							disabled={finishingOrder}
						>
							<FaShoppingBasket />
							Para retirada
						</button>
					</div>
				</Main>
			</Content>
		</Container>
	);
}
